import MissingTokenIcon from './MissingTokenIcon'

export default MissingTokenIcon
